<template>
  <Card
    v-loading="loading"
    :hide-overflow="false"
    class="app-dashboard-numeric-data"
  >
    <div class="app-dashboard-numeric-data__inner">
      <label class="app-dashboard-numeric-data__label">
        <img v-if="icon" :src="icon" class="app-dashboard-numeric-data__icon" />
        <strong>{{ title }}</strong>
        <Hint v-if="description" :message="description" />
      </label>

      <div class="app-dashboard-numeric-data__value">
        <slot>
          {{ value }}
        </slot>
      </div>
    </div>
  </Card>
</template>

<script>
import Hint from '@@/common/Hint';
import Card from '@@/common/Card';

export default {
  name: 'AppDashboardNumericData',
  components: {
    Hint,
    Card,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/require-prop-types
    icon: {
      default: null,
    },
  },
};
</script>
<style lang="scss">
.app-dashboard-numeric-data {
  &__inner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__icon {
    width: 2rem;
    height: 2rem;
  }

  &__value {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
